import { Card, CardContent } from "@mui/material";

const DashboardInfoCard = ({ label, value }) => {
  return (
    <Card
      sx={{
        width: "auto",
        height: "auto",
        borderRadius: "4px",
        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
        padding: "10px",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "scale(1.05)",
          boxShadow: "rgba(0, 0, 0, 0.25) 0px 10px 30px",
        },
      }}
    >
      <CardContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <label
            style={{
              fontWeight: "bold",
              fontSize: "15px",
              color: "#4C5773",
            }}
          >
            {label}
          </label>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "40px",
              padding: "20px",
              color: "#4C5773",
            }}
          >
            {value}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default DashboardInfoCard;
